import { Alert, Anchor, Stack, Text } from "@mantine/core";

export const DynamicFormSuccess = ({ redirectUrl }) => {
    return (
        <Stack gap="md" align="center" py="xl">
            <Alert color="green" title="Thank You!" w="100%">
                <Text>
                    Your application has been successfully submitted. We will contact you if there is interest from our agency.
                </Text>
                {redirectUrl && (
                    <Text mt="md" size="sm">
                        <Anchor href={redirectUrl} target="_self">
                            Click here to return to the site
                        </Anchor>
                    </Text>
                )}
            </Alert>
        </Stack>
    );
};
